// extracted by mini-css-extract-plugin
export default {"container":"Category_container__kjhp6","favoris":"Category_favoris__5LQDl","tool":"Category_tool__tv9h+","news":"Category_news__4n+jY"};